module.exports = __webpack_public_path__ + "static/media/systam-success-story-quote2.f3012269.webp";